import { useEffect } from "react";
import propertyLogo from "../../../assets-user/property.svg";
import BuySellImg from "../../../assets-user/BuySellImg.png";

const BuySellBanner = () => {
  useEffect(() => {}, []);

  return (
    <div className="w-full bg-white px-4 sm:px-6 lg:px-10">
      <div className="mx-auto">
        <div className="relative bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl lg:rounded-3xl overflow-hidden shadow-lg">
          <div className="flex flex-col md:flex-row items-start justify-start">
            <div className="w-full md:w-1/2 p-6 space-y-6">
              <h2 className="font-poppins font-semibold text-xl sm:text-2xl md:text-[28px] tracking-[1%] text-[#2F2F2F] mt-4">
                Looking to buy or sell your Home?
              </h2>
              <p className="font-poppins font-normal text-base sm:text-lg md:text-[20px] tracking-[1%] text-[#7D7D7D] w-full xl:w-4/5">
                Post Your Property on LeadBook today.
              </p>

              <button className="hidden lg:flex items-center space-x-2 bg-red-600 text-white px-6 py-2 rounded-xl font-medium text-sm">
                <img src={propertyLogo} alt="" />
                <span>Post Property</span>
              </button>
            </div>

            <div className="hidden md:flex w-full md:w-1/2 relative">
              <img
                src={BuySellImg}
                alt="Buy Sell Banner"
                className="w-full md:h-[230px] lg:h-[270px] xl:h-[250px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuySellBanner;
